
import React from 'react';
import styled from 'styled-components';
import SkeletonCustom from './SkeletonCustom';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
type Props = {
} & typeof defaultProps;

const defaultProps = {
};
const ListCardFooterSkeleton = function ListCardFooterSkeleton(props: Props) {
  return (
    <Wrapper className='list-card-footer-skeleton'>
      {[1, 2, 3, 4, 5].map(() => (
        <SkeletonCustom
          height="40px"
          width='30px'
          margin='0px 5px 5px 5px'
        />
      ))}
    </Wrapper>
  );
};
ListCardFooterSkeleton.defaultProps = defaultProps;
export default ListCardFooterSkeleton;